// extracted by mini-css-extract-plugin
var _1 = "PostLayout-module__animateUploadProgressBarWidth--JboSO";
var _2 = "PostLayout-module__animatedBackground--B9ev3";
var _3 = "PostLayout-module__hasBanner--jaIws";
var _4 = "PostLayout-module__isMagneticWallExpanded--T4pqi";
var _5 = "PostLayout-module__isTOCExpanded--glEVK";
var _6 = "PostLayout-module__mobile--rx8MK";
var _7 = "PostLayout-module__monitor--SDeyP";
var _8 = "PostLayout-module__postLayoutAbove--sX5i4";
var _9 = "PostLayout-module__postLayoutAboveInner--g0ueD";
var _a = "PostLayout-module__postLayoutBanner--jJBpL";
var _b = "PostLayout-module__postLayoutBannerControls--tjvgd";
var _c = "PostLayout-module__postLayoutBelow--d5WfP";
var _d = "PostLayout-module__postLayoutContainer--PEFC8";
var _e = "PostLayout-module__postLayoutControlBar--J1tTj";
var _f = "PostLayout-module__postLayoutEditor--zFVAl";
var _10 = "PostLayout-module__postLayoutFooterControlBar--DHKEH";
var _11 = "PostLayout-module__postLayoutGutter--rNbUu";
var _12 = "PostLayout-module__postLayoutMagneticWall--fJQy5";
var _13 = "PostLayout-module__postLayoutRoot--cODGj";
var _14 = "PostLayout-module__postLayoutStateBar--risQQ";
var _15 = "PostLayout-module__postLayoutStateBarInner--ZSYPn";
var _16 = "PostLayout-module__postLayoutTOC--XFiZa";
var _17 = "PostLayout-module__readOnly--NL5wC";
var _18 = "PostLayout-module__tablet--B7ZKb";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "hasBanner", _4 as "isMagneticWallExpanded", _5 as "isTOCExpanded", _6 as "mobile", _7 as "monitor", _8 as "postLayoutAbove", _9 as "postLayoutAboveInner", _a as "postLayoutBanner", _b as "postLayoutBannerControls", _c as "postLayoutBelow", _d as "postLayoutContainer", _e as "postLayoutControlBar", _f as "postLayoutEditor", _10 as "postLayoutFooterControlBar", _11 as "postLayoutGutter", _12 as "postLayoutMagneticWall", _13 as "postLayoutRoot", _14 as "postLayoutStateBar", _15 as "postLayoutStateBarInner", _16 as "postLayoutTOC", _17 as "readOnly", _18 as "tablet" }
